import { useQuery } from '@apollo/react-hooks';
import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import {
  GET_CAMPAIGN,
  GET_CAMPAIGN_CONFIG,
  GET_CURRENT_ORGANIZATION,
} from '../../graphql/queries';
import CampaignForm from './CampaignForm';
import Container from '../../shared/Container';
import Section from '../../shared/Section';
import colors from '../../styles/colors';
import { getDateByOffset } from '../../util/Time';
import { AppContext } from '../../context/AppContext';
import * as Price from '../../util/Price';

const BackButton = styled.div`
  cursor: pointer;
  z-index: 30;
  display: flex;
  position: absolute;
  right: 20px;
  top: -60px;
`;

const ToolbarItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
  font-weight: 600;
  color: ${colors.seaGreen};
  font-size: 1.4rem;
  cursor: pointer;
  width: max-content;
  border-radius: 10px;
  padding: 8px 27px;
  background: rgba(26, 188, 156, 0.1);
  @media screen and (max-width: 991px) {
    ${(props) => props.headerDirection === 'column' && 'margin-top:10px'};
  }
  @media screen and (max-width: 767px) {
    padding: 2vw 6vw;
  }
  `;

const EditCampaign = ({ history }) => {
  const { app } = useContext(AppContext);
  const { campaignId } = useParams();
  const [values, setValues] = useState({});
  const { data: organizationData } = useQuery(GET_CURRENT_ORGANIZATION);
  const { getCurrentOrganization: currentOrganisation } = organizationData;

  const referralText = `Click this link to text your friends up to a $${Price.output(
    currentOrganisation?.configurations?.firstTimeRecipientCredit,
    true,
  )} discount to ${currentOrganisation?.name} and you can earn $${Price.output(
    currentOrganisation?.configurations?.affiliateCredit,
    true,
  )} credit at ${currentOrganisation?.name} when their discount is redeemed: ${
    window.location.origin
  }/user/invite/?o=${
    currentOrganisation._id
  }. It's so simple and you can send as many discounts as you would like!`;

  const { data, loading: configLoading } = useQuery(GET_CAMPAIGN_CONFIG, {
    fetchPolicy: 'network-only',
  });

  const { data: campaignData, loading } = useQuery(GET_CAMPAIGN, {
    fetchPolicy: 'network-only',
    variables: {
      campaignId,
    },
  });
  useEffect(() => {
    if (campaignData) {
      const { campaign } = campaignData;
      const InitialValues = {
        id: campaign._id,
        name: campaign.name,
        text: campaign.text,
        unsubscribeMessage: campaign.unsubscribeMessage,
        status: campaign.status,
        type: campaign.type,
        dateTime: getDateByOffset(app.orgTimeZoneOffset, new Date(campaign.dateTime * 1000)),
        imageUrl: campaign.imageUrl,
        sendMode: campaign.sendMode,
        referralOptIn: campaign.referralOptIn || false,
        referralOptInText: referralText || '',
        executionStatus: campaign.executionStatus,
        isUrlShortningEnabled: campaign.isUrlShortningEnabled || false,
        tags: campaign?.tags,
        isTriggerCampaign: campaign?.isTriggerCampaign,
        events: campaign?.events,
      };
      setValues(InitialValues);
    }
  }, [campaignData, app.orgTimeZoneOffset, referralText]);

  return (
    <Container>
      <Section
        headerTitle="Edit Campaign"
        justify="flex-start"
        loading={loading || configLoading}
        width="50%"
      >
        <BackButton
          onClick={() => history.push('/campaigns')}
          data-tip="Back To Campaigns List"
        >
          <ToolbarItem>Cancel</ToolbarItem>
        </BackButton>
        <CampaignForm
          values={values}
          setValues={setValues}
          formType="edit"
          mmsEnabled={data?.getDataForCampaign?.mmsEnabled}
          activeContacts={data?.getDataForCampaign?.activeContacts}
          shortUrlDomain={data?.getDataForCampaign?.shortUrlDomain}
        />
      </Section>
    </Container>
  );
};

export default EditCampaign;
